import React from 'react';

/**
 * Button variants:
 *  primary  – filled brand gradient
 *  ghost    – transparent with border
 *  danger   – red accent
 *  surface  – elevated surface
 */
const Button = ({
  children,
  variant  = 'primary',
  size     = 'md',
  loading  = false,
  disabled = false,
  className = '',
  onClick,
  type = 'button',
}) => {
  const base =
    'relative inline-flex items-center justify-center gap-2 font-syne font-semibold rounded-2xl transition-all duration-200 select-none press-scale focus:outline-none';

  const sizes = {
    sm: 'px-4 py-2.5 text-sm',
    md: 'px-6 py-3.5 text-sm',
    lg: 'px-6 py-4 text-base w-full',
  };

  const variants = {
    primary:
      'bg-gradient-to-r from-brand-600 to-brand-500 text-white brand-glow hover:from-brand-500 hover:to-brand-400 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed',
    ghost:
      'bg-transparent border border-surface-400 text-surface-100 hover:border-brand-500 hover:text-white active:scale-95',
    danger:
      'bg-red-500/10 border border-red-500/30 text-red-400 hover:bg-red-500/20 active:scale-95',
    surface:
      'bg-surface-600 border border-surface-400 text-white hover:bg-surface-500 active:scale-95',
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
    >
      {loading ? (
        <>
          <span
            className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full"
            style={{ animation: 'spin2 0.8s linear infinite' }}
          />
          <span>Please wait…</span>
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
